import React from 'react';

const CloudIcon: React.FC<{ fill: string }> = ({ fill = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    id="Messages-Bubble-Typing--Streamline-Ultimate"
    height="24"
    width="24"
  >
    <desc>
      Messages Bubble Typing Streamline Icon: https://streamlinehq.com
    </desc>
    <g>
      <path
        d="M3.33 18.75a2 2 0 1 0 4 0 2 2 0 1 0 -4 0"
        fill={fill}
        strokeWidth="1"
      />
      <path
        d="M16.1 0.25a7.22 7.22 0 0 0 -6.27 3.63 5.78 5.78 0 0 0 -2.95 -0.8A5.94 5.94 0 0 0 1 9.07a6 6 0 0 0 5.83 6 5.79 5.79 0 0 0 8.22 1.14 7.81 7.81 0 0 0 1.36 0.12c4.21 0 7.26 -3.38 7.26 -8A7.73 7.73 0 0 0 16.1 0.25Zm1.73 10.5a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm-4 -1a1 1 0 1 1 -1 -1 1 1 0 0 1 1 1Zm-6 1a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z"
        fill={fill}
        strokeWidth="1"
      />
      <path
        d="M0.33 22.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0"
        fill={fill}
        strokeWidth="1"
      />
    </g>
  </svg>
);

export default CloudIcon;
